"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueDrivingLicenceNumberValidation = exports.UniqueDriverValidation = exports.AllDriversUniqueValidation = exports.NoUnderwritingRuleFailuresValidation = exports.VehicleRegistrationNumberValidation = exports.UniqueVehicleValidation = exports.RegisteredKeeperAddedAsDriverValidation = exports.DrivingLicenceResolveValidation = exports.DrivingLicenceNumberValidation = void 0;
exports.registerValidators = registerValidators;
const DrivingLicenceNumberValidation_1 = require("./DrivingLicenceNumberValidation");
Object.defineProperty(exports, "DrivingLicenceNumberValidation", { enumerable: true, get: function () { return DrivingLicenceNumberValidation_1.DrivingLicenceNumberValidation; } });
const DrivingLicenceResolveValidation_1 = require("./DrivingLicenceResolveValidation");
Object.defineProperty(exports, "DrivingLicenceResolveValidation", { enumerable: true, get: function () { return DrivingLicenceResolveValidation_1.DrivingLicenceResolveValidation; } });
const RegisteredKeeperAddedAsDriverValidation_1 = require("./RegisteredKeeperAddedAsDriverValidation");
Object.defineProperty(exports, "RegisteredKeeperAddedAsDriverValidation", { enumerable: true, get: function () { return RegisteredKeeperAddedAsDriverValidation_1.RegisteredKeeperAddedAsDriverValidation; } });
const UniqueVehicleValidation_1 = require("./UniqueVehicleValidation");
Object.defineProperty(exports, "UniqueVehicleValidation", { enumerable: true, get: function () { return UniqueVehicleValidation_1.UniqueVehicleValidation; } });
const VehicleRegistrationNumberValidation_1 = require("./VehicleRegistrationNumberValidation");
Object.defineProperty(exports, "VehicleRegistrationNumberValidation", { enumerable: true, get: function () { return VehicleRegistrationNumberValidation_1.VehicleRegistrationNumberValidation; } });
const NoUnderwritingRuleFailuresValidation_1 = require("./NoUnderwritingRuleFailuresValidation");
Object.defineProperty(exports, "NoUnderwritingRuleFailuresValidation", { enumerable: true, get: function () { return NoUnderwritingRuleFailuresValidation_1.NoUnderwritingRuleFailuresValidation; } });
const AllDriversUniqueValidation_1 = require("./AllDriversUniqueValidation");
Object.defineProperty(exports, "AllDriversUniqueValidation", { enumerable: true, get: function () { return AllDriversUniqueValidation_1.AllDriversUniqueValidation; } });
const UniqueDriverValidation_1 = require("./UniqueDriverValidation");
Object.defineProperty(exports, "UniqueDriverValidation", { enumerable: true, get: function () { return UniqueDriverValidation_1.UniqueDriverValidation; } });
const UniqueDrivingLicenceNumberValidation_1 = require("./UniqueDrivingLicenceNumberValidation");
Object.defineProperty(exports, "UniqueDrivingLicenceNumberValidation", { enumerable: true, get: function () { return UniqueDrivingLicenceNumberValidation_1.UniqueDrivingLicenceNumberValidation; } });
const VehicleExclusiveRegistrationNumberValidation_1 = require("./VehicleExclusiveRegistrationNumberValidation");
const DrivingLicenceLookupValidation_1 = require("./DrivingLicenceLookupValidation");
function registerValidators(journeyComponentsManager) {
    journeyComponentsManager.addValidation({
        id: "drivingLicenceResolve",
        method: DrivingLicenceResolveValidation_1.DrivingLicenceResolveValidation
    });
    journeyComponentsManager.addValidation({
        id: "uniqueVehicle",
        method: UniqueVehicleValidation_1.UniqueVehicleValidation
    });
    journeyComponentsManager.addValidation({
        id: "uniqueDriver",
        method: UniqueDriverValidation_1.UniqueDriverValidation
    });
    journeyComponentsManager.addValidation({
        id: "allDriversUnique",
        method: AllDriversUniqueValidation_1.AllDriversUniqueValidation
    });
    journeyComponentsManager.addValidation({
        id: "drivingLicenceNumber",
        method: DrivingLicenceNumberValidation_1.DrivingLicenceNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "drivingLicenceLookup",
        method: DrivingLicenceLookupValidation_1.DrivingLicenceLookupValidation
    });
    journeyComponentsManager.addValidation({
        id: "uniqueDrivingLicenceNumber",
        method: UniqueDrivingLicenceNumberValidation_1.UniqueDrivingLicenceNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "vehicleRegistrationNumber",
        method: VehicleRegistrationNumberValidation_1.VehicleRegistrationNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "registeredKeeperAddedAsDriver",
        method: RegisteredKeeperAddedAsDriverValidation_1.RegisteredKeeperAddedAsDriverValidation
    });
    journeyComponentsManager.addValidation({
        id: "noUnderwritingRuleFailures",
        method: NoUnderwritingRuleFailuresValidation_1.NoUnderwritingRuleFailuresValidation
    });
    journeyComponentsManager.addValidation({
        id: "vehicleExclusiveRegistrationNumberValidation",
        method: VehicleExclusiveRegistrationNumberValidation_1.VehicleExclusiveRegistrationNumberValidation
    });
}
//# sourceMappingURL=index.js.map